<rt-dialog-header>
  <div layout-full-width>
    <div layout layout-space-between>
      <rt-heading variant="heading large-x-dialog-header">{{
        translationKey.dialog_2fa_app.step_2.header | translate
      }}</rt-heading>
      <span layout layout-align-items-center margin-left-auto>
        {{ translationKey.dialog_2fa_app.step_2.header_step | translate }}
      </span>
    </div>
    <span>{{ translationKey.dialog_2fa_app.step_2.header_description | translate }}</span>
  </div>
</rt-dialog-header>
<rt-dialog-body variant="white">
  <div layout-horizontal>
    <rt-box class="qr-code" margin-right>
      <qr-code [size]="278" [value]="otpauthUri"></qr-code>
    </rt-box>
    <div class="activation-code" layout-vertical>
      <rt-infobox [iconName]="'info-outline'" [isDismissible]="false" margin-bottom>
        {{ translationKey.dialog_2fa_app.step_2.infobox | translate }}
      </rt-infobox>
      <rt-label>{{ translationKey.dialog_2fa_app.step_2.code_header | translate }}</rt-label>
      <rt-code-input
        (clearError)="onClearError()"
        [formControl]="codeControl"
        [error]="codeError"
      ></rt-code-input>
      <span
        [innerHTML]="translationKey.dialog_2fa_app.step_2.manual_code | translate"
        margin-top
      ></span>
      <span class="secret-code">{{ otpSecret }}</span>
    </div>
  </div>
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true" variant="white">
  <rt-button (click)="onGoBackClick()" variant="outline" class="optional">
    <rt-icon name="chevron-left"></rt-icon>
    <span>{{ translationKey.common.goBack | translate }}</span>
  </rt-button>
  <rt-button (click)="onCancelClick()" variant="plain">{{
    translationKey.common.cancel | translate
  }}</rt-button>
  <rt-button
    [disabled]="codeControl.value.length !== 6"
    (click)="enable()"
    [loading]="isLoading"
    variant="primary"
  >
    {{ translationKey.dialog_2fa_app.step_2.cta | translate }}
  </rt-button>
</rt-dialog-footer>
